export default {
  apiKey: "AIzaSyDBOtymJ_CV579JRWV_3aiMsrt-aZo5Wac",
  authDomain: "uvi24-17bb5.firebaseapp.com",
  databaseURL: "https://uvi24-17bb5.firebaseio.com",
  projectId: "uvi24-17bb5",
  storageBucket: "uvi24-17bb5.appspot.com",
  messagingSenderId: "779001999673",
  appId: "1:779001999673:web:0bfc4db74cc7fd4bf1b8e8",
  measurementId: "G-3KYMRCTNX8"
};
